export default __webpack_public_path__ + "scene5_1_bgf53ae1.png";